import React from 'react';
import TextBase from './TextBase';
import { TText } from './types';

const Regular = ({ as = 'span', color = '', ...rest }: TText) => (
  <TextBase {...rest} as={as} kind="body-regular" color={color} />
);

export default Regular;
